import React, { useState, useEffect } from 'react'
import { Panel, Message, Button } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import SearchLawForm from '../saveLawTracking/SearchLawForm'
import CallBookNoticeForm from './CallBookNoticeForm'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import {
  searchCallBookNotice,
  saveCallBookNotice,
  getCallBookNoticeByid,
  sendRequestApproveCallBookNotice,
  approvedCallBookNotice,
} from '../../redux/actions/callBookNotice'
import moment from 'moment'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import ButtonPanelWidget from '../ButtonPanelWidget'
import SearchLawResultTable from '../saveLawTracking/SearchLawResultTable'
import LitigationView from '../saveLawTracking/LitigationView'
import notification from '../../utils/notification'
import { SAVE_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../../widgets/confirm/ConfirmWidget'
import { getLitigationFile } from '../../redux/actions/legal'

export default function CallBookNoticeWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [searchResult, setSearchResult] = useState()
  const [searchLawData, setSearchLawData] = useState(null)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [litigationId, setLitigationId] = useState(null)
  const [errorMsg, setErrorMsg] = useState()
  const [clearValue, setClearValue] = useState(false)
  const [selectRowData, setSelectRowData] = useState()
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [docTypeValue, setDocTypeValue] = useState(0)
  const [submitApprove, setSubmitApprove] = useState()

  const [requestApproveReq, setRequestApproveReq] = useState()
  const [isShowConfirmRequest, setIsShowConfirmRequest] = useState(false)

  useEffect(() => {
    projectId != 'menu' && getCallBookNotice(projectId)
  }, [projectId])

  useEffect(() => {
    if (formSchema?.form?.searchResult) {
      setSearchResult(formSchema?.form?.searchResult)
    }
  }, [formSchema])

  const getCallBookNotice = async (litigationId, noticeId) => {
    setIsLoading(true)
    startLoading()

    try {
      //setSearchLawData(null)
      const response = await getCallBookNoticeByid(litigationId, noticeId)
      console.log('ress pose ', response)
      setDocTypeValue(response?.inputForm?.docType?.value || 0)
      setSearchLawData(response)
      setLitigationId(response?.litigationId || response.litigationInfo.id || '')
    } catch (error) {
      console.error(error)
    }

    doneLoading()
    setIsLoading(false)
  }

  const onSearchLitagation = async (request) => {
    setIsLoading(true)
    startLoading()
    setErrorMsg(null)
    try {
      const response = await searchCallBookNotice(request)
      setSearchResult(response)
      //setSearchLawData(response)
    } catch (error) {
      console.error(error)
    }

    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = async (data) => {
    console.log('data', data)

    const formData = new FormData()

    data.file &&
      data.file?.forEach((element) => {
        formData.append('Files', element.blobFile)
      })

    formData.append('Id', searchLawData.id || '')
    formData.append('NoticeType', data.docType)
    formData.append('IsRequestApprove', false)
    formData.append('Note', data.detail || '')
    formData.append('Note', data.detail || '')

    formData.append('DeleteFileIds', data.deleteFileIds || [])

    handleSaveNotice(formData)
  }

  const onSubmitRequest = async (data) => {
    console.log('data', data)

    const formData = new FormData()

    data.file &&
      data.file?.forEach((element) => {
        formData.append('Files', element.blobFile)
      })

    formData.append('Id', searchLawData.id || '')
    formData.append('NoticeType', data.docType)
    formData.append('IsRequestApprove', true)
    formData.append('Note', data.detail || '')

    formData.append('DeleteFileIds', data.deleteFileIds || [])

    setIsShowConfirmRequest(true)
    setRequestApproveReq(formData)
  }

  const handleSaveNotice = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await saveCallBookNotice(request, litigationId)
      console.log('response ', response)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 10000,
        })
        setErrorMsg(null)
        setValueNullField()
        setSearchLawData(null)
        setIsShowConfirm(false)
      } else {
        setErrorMsg({ type: 'error', description: response?.errorMessage })
      }
    } catch (error) {
      console.error(error)
      notification.open('error', {
        title: error?.response?.data?.errors?.message || SAVE_ERR_MSG,
        duration: 10000,
      })
    }

    setIsShowConfirmRequest(false)
    doneLoading()
    setIsLoading(false)
  }

  const handleApproveNotice = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await approvedCallBookNotice(litigationId, request)
      console.log('response ', response)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 10000,
        })
        setErrorMsg(null)
        setValueNullField()
        setSearchLawData(null)
      } else {
        setErrorMsg({ type: 'error', description: response?.errorMessage })
      }
    } catch (error) {
      console.error(error)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || SAVE_ERR_MSG,
        duration: 10000,
      })
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const onSubmitCancelSearchLegalManagement = () => {
    setSearchLawData(null)
  }

  const setValueNullField = () => {
    for (const key in getValues()) {
      if (key == 'lawStatus' || key == 'limitation' || key == 'noteOfTracking' || key == 'file') {
        setValue(key, null)
      }
    }

    setClearValue(true)
    setTimeout(() => {
      setClearValue(false)
    }, 500)

    clearErrors()
  }

  const handleGetSchemaOnReload = async (pagesize, pagenumber) => {
    const request = {
      lawType: getValues('lawType'),
      litigationName: getValues('litigationName'),
      projectCode: getValues('projectCode'),
      docNumberOfPurchase: getValues('docNumberOfPurchase'),
      contractNumberRef: getValues('contractNumberRef'),
      lawStatus: getValues('lawStatus'),
      lawStatus: getValues('lawStatus'),
      projectName: getValues('projectName'),
      department: getValues('department'),
      pageNumber: pagenumber || 1,
      pageSize: pagesize || 5,
    }

    onSearchLitagation(request)
  }

  const handleOnSelectRowData = (rowData) => {
    // console.log('rowData', rowData)
    sessionStorage.setItem('projectId', rowData.litigationId)

    setSelectRowData(rowData)
    getCallBookNotice(rowData.litigationId, rowData.litigationNoticeId || '')
  }

  const handlerOnChangeDocType = (value) => {
    console.log('handlerOnChangeDocType ', value)
    setDocTypeValue(value)
  }

  const onSubmitApprove = (data) => {
    console.log('onSubmitApprove ', data)
    const request = {
      id: searchLawData.id,
      approveType: 1,
      comment: data.approveComment,
    }

    if (searchLawData?.inputForm?.buttonText?.approveButtonName) {
      setIsShowConfirm(true)
      setSubmitApprove(request)
    } else {
      handleApproveNotice(request)
    }
  }

  const onSubmitReject = (data) => {
    console.log('onSubmitReject ', data)
    const request = {
      id: searchLawData.id,
      approveType: 2,
      comment: data.approveComment,
    }

    setIsShowConfirm(true)
    setSubmitApprove(request)
  }

  const onDownload = async (fileObj) => {
    startLoading()
    var file = await getLitigationFile(fileObj.id)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    var file = await getLitigationFile(fileObj.id)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded bordered>
        {formSchema.form.searchForm && !searchLawData && (
          <SearchLawForm
            schema={formSchema.form.searchForm}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            onSubmitData={onSearchLitagation}
            onCancelData={onSearchLitagation}
            PanelExpanded={projectId != 'menu'}
          />
        )}

        {searchResult && !searchLawData && (
          <div style={{ marginTop: 20 }}>
            <SearchLawResultTable
              schema={searchResult}
              pagination={true}
              loading={isLoading}
              onReload={handleGetSchemaOnReload}
              onSelect={handleOnSelectRowData}
            />
          </div>
        )}

        {searchLawData?.litigationInfo && <LitigationView schema={searchLawData?.litigationInfo} />}

        {searchLawData?.inputForm && (
          <>
            <CallBookNoticeForm
              schema={searchLawData}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              clearErrors={clearErrors}
              onChangeDocType={handlerOnChangeDocType}
              // active={active}
              // onSubmitData={handleSubmit(onSubmitSaveLegalManagement)}
              onDownload={onDownload}
              onPreview={onPreview}
            />

            {isLoading && <OverlayLoader />}

            {searchLawData.inputForm && <hr />}

            {errorMsg && (
              <Message
                showIcon
                type={errorMsg.type}
                description={errorMsg.description}
                style={{ marginBottom: 20 }}
              />
            )}

            {searchLawData.inputForm && (
              <>
                {searchLawData?.inputForm?.isApproveLevel ? (
                  <>
                    {searchLawData?.inputForm?.buttonText?.saveButtonName && (
                      <SaveButton
                        disabled={searchLawData?.disabled}
                        onClick={handleSubmit(onSubmitApprove)}
                      >
                        {searchLawData?.inputForm?.buttonText?.saveButtonName || ''}
                      </SaveButton>
                    )}

                    {searchLawData?.inputForm?.buttonText?.approveButtonName && (
                      <>
                        <Button
                          disabled={searchLawData?.disabled}
                          onClick={handleSubmit(onSubmitReject)}
                          appearance="primary"
                          style={{
                            marginRight: 10,
                            marginBottom: 10,
                          }}
                        >
                          {searchLawData?.inputForm?.buttonText?.approveButtonName || ''}
                        </Button>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {searchLawData?.inputForm?.buttonText?.saveButtonName && (
                      <SaveButton
                        disabled={searchLawData?.disabled}
                        onClick={handleSubmit(onSubmit)}
                      >
                        {searchLawData?.inputForm?.buttonText?.saveButtonName || ''}
                      </SaveButton>
                    )}

                    {searchLawData?.inputForm?.buttonText?.approveButtonName && (
                      //docTypeValue != 0 &&
                      <>
                        <Button
                          disabled={searchLawData?.disabled}
                          onClick={handleSubmit(onSubmitRequest)}
                          appearance="primary"
                          style={{
                            marginRight: 10,
                            marginBottom: 10,
                          }}
                        >
                          {searchLawData?.inputForm?.buttonText?.approveButtonName || ''}
                        </Button>
                      </>
                    )}
                  </>
                )}

                {searchLawData?.inputForm?.buttonText?.cancelButtonName && (
                  <>
                    <CancelButton
                      //disabled={searchLawData?.inputForm?.buttonText?.disabled}
                      onClick={() => {
                        setSearchLawData(null)
                        onSubmitCancelSearchLegalManagement()
                        setValueNullField()
                        setSelectRowData(null)
                      }}
                    >
                      {searchLawData?.inputForm?.buttonText?.cancelButtonName || ''}
                    </CancelButton>
                  </>
                )}

                <ConfirmWidget
                  title={
                    'ยืนยัน' +
                    (submitApprove?.approveType == 1
                      ? 'อนุม้ติ'
                      : searchLawData?.inputForm?.buttonText?.approveButtonName)
                  }
                  show={isShowConfirm}
                  detail={
                    'ยืนยัน' +
                    (submitApprove?.approveType == 1
                      ? 'อนุม้ติ'
                      : searchLawData?.inputForm?.buttonText?.approveButtonName)
                  }
                  onCancle={() => setIsShowConfirm(false)}
                  onConfirm={() => {
                    setIsShowConfirm(false)
                    handleApproveNotice(submitApprove)
                  }}
                />

                <ConfirmWidget
                  title={'ยืนยัน' + searchLawData?.inputForm?.buttonText?.approveButtonName}
                  show={isShowConfirmRequest}
                  detail={'ยืนยัน' + searchLawData?.inputForm?.buttonText?.approveButtonName}
                  onCancle={() => setIsShowConfirmRequest(false)}
                  onConfirm={() => {
                    setIsShowConfirmRequest(false)
                    handleSaveNotice(requestApproveReq)
                  }}
                />
              </>
            )}
          </>
        )}
      </Panel>
    </>
  )
}
